<template>
  <tr>
    <td data-label="Name">
      <strong>
        <span v-if="birthday" class="fa fa-lg fa-birthday-cake text-pink"></span>
        {{ manager.fullName }}
      </strong>
    </td>
    <td data-label="Title">
      {{ manager.positionTitle }}
    </td>
    <td data-label="Email">
      <a :href="'mailto:' + manager.email" target="_top">
        {{ manager.email }}
      </a>
    </td>
    <td data-label="Mobile">
      <a :href="'tel:' + mobile">
        {{ manager.phone }}
      </a>
    </td>
    <td data-label="Phone (BH)">
      <a :href="'tel:' + businessPhone">
        {{ manager.businessPhone }}
      </a>
    </td>
    <td class="button-2">
      <button class="my-2 btn btn-warning" @click="editCode()">
        <i class="fa fa-edit" /> Edit
      </button>
      <button class="my-2 btn btn-danger" @click="deleteCode()">
        <i class="fa fa-trash" /> Delete
      </button>
      <button class="my-2 btn btn-info" @click="generateAcceptanceRateReport()">
        <i class="fa fa-sticky-note" /> Generate Report
      </button>
      <button class="my-2 btn btn-primary" @click="editManagerAcceptanceRateReport()">
        <i class="fa fa-fw fa-copy" /> View Reports
      </button>
      <button class="my-2 btn btn-primary" v-if="manager.password && !$route.meta.client" @click="loginAsUser()">
        <i class="fa fa-sign-in-alt" /> Log In As User
      </button>
      <download-input
        :options="{ label: 'Download vCard', permalink: 'downloadVCard', button: true }"
        :value="{ uuid: manager.uuid }" />
    </td>
  </tr>
</template>

<script>
  import DownloadInput from '@/components/inputs/DownloadInput'
  import {
    LOGIN_AS_USER,
    EDIT_COMPANY_MANAGER,
    DELETE_COMPANY_MANAGER,
    GENERATE_ACCEPTANCE_RATE_REPORT,
    EDIT_ACCEPTANCE_RATE_REPORT
  } from '@/vuex/types'
  export default {
    name: 'CompanyManagerRow',
    props: {
      object: {
        type: Object
      },
      index: {
        type: Number
      }
    },
    components: {
      DownloadInput
    },
    computed: {
      birthday () {
        if (this.manager.dateOfBirth) {
          return moment().format('DD-MM') === moment(this.manager.dateOfBirth).format('DD-MM')
        } else {
          return false
        }
      },
      mobile () {
        if (this.manager.phone) {
          return this.manager.phone.replace(/\D/g, '')
        } else {
          return ''
        }
      },
      businessPhone () {
        if (this.manager.businessPhone) {
          return this.manager.businessPhone.replace(/\D/g, '')
        } else {
          return ''
        }
      },
      manager () {
        return {
          ...this.object
        }
      }
    },
    methods: {
      loginAsUser () {
        this.$store.dispatch(LOGIN_AS_USER, this.manager)
      },
      editCode () {
        this.$store.dispatch(EDIT_COMPANY_MANAGER, this.manager)
      },
      deleteCode () {
        this.$store.dispatch(DELETE_COMPANY_MANAGER, this.manager)
      },
      generateAcceptanceRateReport () {
        this.$store.dispatch(GENERATE_ACCEPTANCE_RATE_REPORT, this.manager)
      },
      editManagerAcceptanceRateReport () {
        this.$store.dispatch(EDIT_ACCEPTANCE_RATE_REPORT, this.manager)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/rows/CompanyManager.vue